import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function WifiIcon(props) {
    return (
        <SvgIcon {...props}>
            <path clipRule="evenodd" d="M2 7.32001C4.86396 5.16355 8.38149 3.99574 12.0001 4.00001C15.6187 3.99574 19.1362 5.16355 22.0002 7.32001L20.1232 9.70001C17.7935 7.95494 14.9379 7.00892 12.0001 7.00892C9.06223 7.00892 6.20663 7.95494 3.87694 9.70001L2 7.32001ZM5.75385 12.08L7.63077 14.46C8.88007 13.5129 10.4175 12.9987 12 12.9987C13.5825 12.9987 15.1199 13.5129 16.3692 14.46L18.2462 12.08C16.4545 10.7388 14.2588 10.0117 12 10.0117C9.74116 10.0117 7.54549 10.7388 5.75385 12.08ZM12 16C11.0947 15.9999 10.2149 16.2917 9.49744 16.83L12 20L14.5026 16.83C13.7851 16.2917 12.9053 15.9999 12 16Z" fill="#62666B" fillRule="evenodd" />
        </SvgIcon>
    );
}

export default WifiIcon;
